/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_Feature_4_TitleInputs */

const es_home_nexy_feature_4_title = /** @type {(inputs: Home_Nexy_Feature_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversación Natural`)
};

const en_home_nexy_feature_4_title = /** @type {(inputs: Home_Nexy_Feature_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural Conversation`)
};

/**
* | output |
* | --- |
* | "Natural Conversation" |
*
* @param {Home_Nexy_Feature_4_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_feature_4_title = /** @type {((inputs?: Home_Nexy_Feature_4_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_Feature_4_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_feature_4_title(inputs)
	return en_home_nexy_feature_4_title(inputs)
});
export { home_nexy_feature_4_title as "home.nexy.feature_4_title" }